var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visivel
    ? _c(
        "button",
        {
          staticClass: "jsn",
          attrs: { type: "button" },
          on: { click: _vm.executar }
        },
        [
          _c("span", { staticClass: "jsn__rotulo" }, [_vm._v("Próximo passo")]),
          _c("span", { staticClass: "jsn__passo" }, [
            _vm._v(_vm._s(_vm.proximo.label))
          ]),
          _vm.proximo.stageLabel
            ? _c("span", { staticClass: "jsn__etapa" }, [
                _vm._v(" " + _vm._s(_vm.proximo.stageLabel) + " ")
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }